import React from 'react'
import PropTypes from 'prop-types'

import { NAV_MODULE_ICON } from '../../constants'

import DeviceCategoryLink from './DeviceCategoryLink'
import messages from './messages'
import { getVersionIcon } from '../../helpers/utils'

/**
 * Arranges two flagship `DeviceCategoryLink` list items in exclusive scenarios
 * based on supplied params as predicates.
 *
 * @param {{
 *    query: object,
 *    language: string,
 *    onSvgLoad: (string) => HTMLOrSVGImageElement,
 *    showHomeLink?: boolean,
 *    showExpressLink?: boolean
 * }}
 * @return {React.ReactNode}
 */
const DeviceLandingCategories = ({
  query,
  language,
  onSvgLoad,
  showHomeLink = true,
  showExpressLink = true,
  version
}) => {
  const translated = messages[language]

  return (
    <>
      <li>
        {showHomeLink && (
          <DeviceCategoryLink
            homeLink
            id="nav-home"
            ariaLabel={translated.home}
            pathname="/"
            query={query}
            iconSrc={getVersionIcon(NAV_MODULE_ICON.home, version)}
            onSvgLoad={onSvgLoad}
            svgKey="home"
            title={translated.home}
            linkClassName="nav-link"
          />
        )}
      </li>
      <li>
        {showExpressLink && (
          <DeviceCategoryLink
            id="nav-expresshelp-link"
            ariaLabel={translated.expresshelp}
            pathname="/expresshelp"
            query={query}
            iconSrc={getVersionIcon(NAV_MODULE_ICON.faq, version)}
            onSvgLoad={onSvgLoad}
            svgKey="faqs"
            title={translated.expresshelp}
            linkClassName="nav-link"
          />
        )}
      </li>
    </>
  )
}

DeviceLandingCategories.propTypes = {
  query: PropTypes.object.isRequired,
  language: PropTypes.string.isRequired,
  onSvgLoad: PropTypes.func.isRequired,
  showHomeLink: PropTypes.bool,
  showExpressLink: PropTypes.bool,
  version: PropTypes.string
}

export default DeviceLandingCategories



// WEBPACK FOOTER //
// ./src/components/SubHeader/DeviceLandingCategories.js